/**
 * Created by mongoose on 22/04/16.
 */
import isFinite from "lodash/isFinite";
import moment from "moment";

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

export function dateDiffInDays(date, otherDate) {
  if (!date || !otherDate) {
    return null;
  }

  // Discard the time and time-zone information.
  const utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const utc2 = Date.UTC(otherDate.getFullYear(), otherDate.getMonth(), otherDate.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function calculateDaysBetweenDates({ startDate, endDate }) {
  const ariStart = moment(startDate).startOf("day").toDate();
  const ariEnd = moment(endDate).startOf("day").toDate();
  return dateDiffInDays(ariStart, ariEnd);
}

export function parseDate(dateStr) {
  return moment(dateStr).toDate();
}

export function formatDate(date, format) {
  return moment(date).format(format);
}

export function parseIntOrNull(str) {
  const int = parseInt(str, 10);
  return isFinite(int) ? int : null;
}

export function addDays(date, days) {
  if (!(Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime()))) {
    return null;
  }
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function addMonth(date, month) {
  if (!(Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime()))) {
    return null;
  }
  const result = new Date(date);
  result.setMonth(result.getMonth() + month);
  return result;
}

export function parseDateOrNull(str) {
  if (!str) {
    return null;
  }
  const [day, month, year] = str.split("-");
  const date = new Date(year, month - 1, day);
  return Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime())
    ? date
    : null;
}

function getDayIndex(day) {
  switch (day) {
    case "SUNDAY":
      return 0;
    case "MONDAY":
      return 1;
    case "TUESDAY":
      return 2;
    case "WEDNESDAY":
      return 3;
    case "THURSDAY":
      return 4;
    case "FRIDAY":
      return 5;
    case "SATURDAY":
      return 6;
    default:
      return 7;
  }
}

export function getTranslatedDaysOfTheWeek(formatDateFunc, givenDays, format, firstDay) {
  let startingDate = moment("20160807", "YYYYMMDD").toDate();
  if (typeof firstDay !== "undefined" && firstDay === 1) {
    startingDate = moment("20160808", "YYYYMMDD").toDate();
  }

  const days = new Array(7).fill(true).map((__, idx) => {
    const weekDay = formatDateFunc(addDays(startingDate, idx), {
      weekday: format || "short",
    });

    return weekDay.slice(0, 2);
  });
  if (givenDays) {
    return givenDays.map(day => {
      return days[getDayIndex(day)];
    });
  }
  return days;
}

export function getTranslatedMonthsOfTheYear(formatDateFunc, format) {
  const startingDate = moment("20160101", "YYYYMMDD").toDate();
  const months = new Array(12).fill(true).map((__, idx) => {
    return formatDateFunc(addMonth(startingDate, idx), {
      month: format || "long",
    });
  });
  return months;
}

export function getDateDifferenceInHours(startDate, endDate) {
  if (
    !(Object.prototype.toString.call(startDate) === "[object Date]" && !isNaN(startDate.getTime()))
  ) {
    return null;
  }
  if (!(Object.prototype.toString.call(endDate) === "[object Date]" && !isNaN(endDate.getTime()))) {
    return null;
  }

  const start = moment(startDate);
  const end = moment(endDate);
  const duration = moment.duration(end.diff(start));
  return duration.asHours();
}

export function toEndOfDay(date) {
  if (!(Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime()))) {
    return null;
  }
  return moment(date).endOf("day").toDate();
}

export function isRangeContained(startDate, endDate, validFrom, validTo) {
  const evalValidFrom = moment(validFrom || new Date(-8640000000000000));
  const evalValidTo = moment(validTo || new Date(8640000000000000));
  startDate = moment(startDate);
  endDate = moment(endDate);
  return (
    ((startDate.isAfter(evalValidFrom) || startDate.isSame(evalValidFrom)) &&
      (endDate.isBefore(evalValidTo) || endDate.isSame(evalValidTo))) ||
    ((startDate.isAfter(evalValidFrom) || startDate.isSame(evalValidFrom)) &&
      (startDate.isBefore(evalValidTo) || startDate.isSame(evalValidTo))) ||
    (endDate.isAfter(evalValidFrom) &&
      (endDate.isBefore(evalValidTo) || endDate.isSame(evalValidTo))) ||
    ((evalValidFrom.isAfter(startDate) || evalValidFrom.isSame(startDate)) &&
      (evalValidTo.isBefore(endDate) || evalValidTo.isSame(endDate)))
  );
}

export function formatTDate(date) {
  return date.split("T").join(" ");
}
